import { createTheme, ThemeProvider } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from 'services/auth-service';
import RoutesInfo from 'services/routesInfo';
import { initGA, logPageView } from './services/google-analytics';
import ReactGA from 'react-ga4';

const queryClient = new QueryClient();

// Create a theme instance to have 'Figtree' as the default font across all MUI elements
const theme = createTheme({
  typography: {
    fontFamily: ['Figtree', 'sans-serif', 'Arial'].join(',')
  }
});

function App() {
  // Initialize tracking to log app usage in Google Analytics
  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT === 'prod') {
      initGA(); // Initialize GA
      logPageView(window.location.pathname + window.location.search); // Log initial page load

      // Send custom event to track app load
      ReactGA.event({
        category: 'App',
        action: 'App Loaded',
        label: window.location.pathname + window.location.search
      });
    }
    logPageView(window.location.pathname + window.location.search); // Track initial page load
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <ReactQueryDevtools initialIsOpen={false} />
            <BrowserRouter>
              <RoutesInfo />
            </BrowserRouter>
            <ToastContainer
              position="bottom-right"
              autoClose={5000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
              transition={Slide}
              style={{ width: '400px' }}
            />
          </LocalizationProvider>
        </QueryClientProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
